import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLogin } from "../services/api/services";
import LoadingPanel from "../components/LoadingPanel";
import { toast } from "react-toastify";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginState, login] = useLogin();
  const handleLogin = (e: any) => {
    e.preventDefault();
    login({
      email: email,
      password: password,
    });
    console.log("Login clicked:", { email, password });
  };
  console.log({loginState});
  
  useEffect(() => {
    if (loginState.data?.status !== 0) {
      toast.error(loginState.data?.message);
    }
  }, [loginState]);
  return (
    <>
      {loginState?.loading && (
        <LoadingPanel fullScreen message="Logging In..." />
      )}
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: "400px" }}>
          <h2 className="text-center mb-4">Login</h2>
          <form onSubmit={handleLogin}>
            {/* Email */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email address
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* Password */}
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="d-flex justify-content-between mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="rememberMe"
                />
                <label className="form-check-label" htmlFor="rememberMe">
                  Remember Me
                </label>
              </div>
              <a
                href="/forgot-password"
                className="text-primary text-decoration-none"
              >
                Forgot Password?
              </a>
            </div>

            {/* Login Button */}
            <button type="submit" className="btn btn-primary w-100">
              Login
            </button>

            {/* Sign Up Link */}
            <p className="text-center mt-3">
              Don't have an account?{" "}
              <a href="/signup" className="text-primary text-decoration-none">
                Sign Up
              </a>
            </p>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
